import Task from "components/Task";
import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import CloseIcon from "assets/icons/close.svg?react";
import ReactDOM from "react-dom";

const TaskModal: FC<Props> = ({ setTask, task }) => {
  return ReactDOM.createPortal(
    <div className={styles.modal}>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.header}>
            <div className={styles.title}>Zadanie</div>
            <div className={styles.iconBox}>
              <CloseIcon
                className={styles.icon}
                onClick={() => setTask(null)}
              />
            </div>
          </div>
          <div className={styles.body}>
            <Task setTask={setTask} task={task} />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default TaskModal;
